export { Heading } from './Heading.js';
//# sourceMappingURL=index.js.map
